
import "@/styles/pages/videoEditor/index.css";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            /* eslint-disable prettier/prettier */

new Vue({
  created($, apower) {
    window.addEventListener("scroll", handleScroll);
    function handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var windowH = document.body.clientHeight;

      var inviewL = document.querySelector("#inview-left");
      var offsetTopL = inviewL.offsetTop;
      var heightL = inviewL.clientHeight;

      var inviewR = document.querySelector("#inview-right");
      var offsetTopR = inviewR.offsetTop;
      var heightR = inviewR.clientHeight;

      if (
        scrollTop > offsetTopL - windowH &&
        scrollTop < offsetTopL + heightL
      ) {
        document.querySelector(".animate-left").className =
          "animate-left inview";
      } else {
        document.querySelector(".animate-left").className = "animate-left";
      }

      if (
        scrollTop > offsetTopR - windowH + 100 &&
        scrollTop < offsetTopR + heightR
      ) {
        document.querySelector(".animate-right").className =
          "animate-right inview";
      } else {
        document.querySelector(".animate-right").className = "animate-right";
      }
    }

    const aiSubtitle = document.querySelector(".click-aiSubtitle");
    aiSubtitle && aiSubtitle.addEventListener("click", () => {
      pointUpload(
        {
          event: "click-aisubtitle",
          page_name: "online-video-editor-page",
        },
        true
      );
      pointUpload(
        {
          event: "click-aisubtitle",
          page_name: "online-video-editor-page",
        },
        false
      );
    });

    const aiChatVideo = document.querySelector(".click-chatVideo");
    aiChatVideo && aiChatVideo.addEventListener("click", () => {
      pointUpload(
        {
          event: "click-chatvideo",
          page_name: "online-video-editor-page",
        },
        true
      );
      pointUpload(
        {
          event: "click-chatvideo",
          page_name: "online-video-editor-page",
        },
        false
      );
    });

    async function pointUpload(params = {}, isRec = false) {
      const id = isRec ? "293" : "327";
      const language = apower.lang;
      const browser = window.navigator.userAgent;
      const host = window.location.host;
      let url = `https://wx-user-behavior.cn-hongkong.log.aliyuncs.com/logstores/${id}/track?APIVersion=0.6.0&language=${language}&browser=${browser}&host=${host}`;
      const searchParams = new window.URLSearchParams();
      const mergeParams = {
        online_web: "1",
        ...params,
      };
      for (const paramsKey in mergeParams) {
        searchParams.append(paramsKey, mergeParams[paramsKey]);
      }
      if (searchParams.toString()) {
        url += `&${searchParams.toString()}`;
      }

      await fetch(url);
    }

    replaceDownloadHref();

    function replaceDownloadHref() {
      const downloadBtns = document.querySelectorAll("a.download");
      downloadBtns.forEach(item => item.href = "https://download.aoscdn.com/down.php?softid=lighteditor-saas-RL-online-editor");
    }
  },
});

          })
        